import * as React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import { SEO, Button } from 'components';

function NotFoundPage() {
  return (
    <Container>
      <InnerContainer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 1 }}>
        <h2>Seems like we lost this page</h2>
        <h1>404</h1>
        <div />
      </InnerContainer>
      <Overlay
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1.5 }}>
        <h2>Let&apos;s get you back home</h2>
        <Button to="/" style={{ width: '180px' }}>
          Back To Home
        </Button>
      </Overlay>
    </Container>
  );
}

const Container = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
  position: relative;

  h1 {
    font-size: 6rem;
    line-height: 1;
  }

  h2 {
    color: var(--connolly-red);
    font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
    font-size: 1.5rem;
    font-weight: 300;
  }

  @media screen and (width >= 48rem) {
    justify-content: center;

    h2 {
      font-size: 2rem;
    }

    h1 {
      font-size: 18rem;
    }
  }
`;

const InnerContainer = styled(motion.div)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;
  margin: 0 auto;
  padding: 3rem 0 6rem;

  @media screen and (width >= 48rem) {
    gap: 3rem;
    padding: 6rem 0 12rem;
  }

  @media screen and (width >= 75rem) {
    gap: 3.25rem;
  }
`;

const Overlay = styled(motion.div)`
  align-items: center;
  backdrop-filter: blur(20px);
  background: rgb(149 164 177 / 46%);
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  height: 50%;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 100%;

  @media screen and (width >= 48rem) {
    height: 50%;
    gap: 2rem;
  }
`;

export function Head() {
  return (
    <SEO
      title="404: Not Found"
      description="Seems like we lost this page! Let's get you back home."
    />
  );
}

export default NotFoundPage;
